<template>
    <div>
        <section class="primary-filters">
            <div class="filters">
                <div>
                    <a v-if="canGeolocate" href="#" @click.prevent="geolocate">
                        Use My Current Location

                        <span v-if="geolocating">Finding...</span>
                    </a>

                    <input class="zip-code" v-model="selections.zip" type="text" placeholder="Zip code" />
                </div>

                <v-select
                    v-model="selections.type"
                    label="name"
                    :options="filters.types"
                    placeholder="Facility Type"
                />
            </div>
            <slot></slot>
        </section>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import VSelect from 'vue-select';
import LocationSearch from './LocationSearch.vue';

/* global google */
export default {
    components: {VSelect, LocationSearch},

    data() {
        return {
            selections: this.newSelections(),
            count: 0,
            canGeolocate: false,
            geolocating: false,
        };
    },

    computed: {
        ...mapState(['filters', 'totalLocations', 'locationsLoaded']),

        routeQuery() {
            return Object.keys(this.selections).reduce((params, key) => {
                const value = this.getSelectionValue(key);

                if (value) {
                    params[key] = this.getSelectionValue(key);
                }

                return params;
            }, {});
        },
    },

    watch: {
        totalLocations() {
            this.countUp();
        },
    },

    mounted() {
        window.qhsEvents.$on('renderedMap', () => {
            this.setLocationDistanceFromZip();
        });
    },

    beforeDestroy() {
        window.qhsEvents.$off('renderedMap');
    },

    async created() {
        if (navigator.geolocation) {
            this.canGeolocate = true;
        }

        this.$watch('selections.zip', function(value, oldValue) {
            if (!this.locationsLoaded) {
                return;
            }

            if (value != oldValue && (!value || value.length === 5)) {
                this.$router.push({path: this.basePath, query: this.routeQuery});
                this.setLocationDistanceFromZip();
            }
        });

        this.$store.dispatch('updateFilterSelections', this.$route.query);
        await this.$store.dispatch('getLocationFilters', this.$route.query);
        this.selections = this.newSelections(this.$route.query);

        this.$watch('selections.location', function() {
            const selections = this.newSelections();
            Object.keys(selections).forEach(key => {
                if (key != 'location') {
                    this.selections[key] = selections[key];
                }
            });
        });

        this.$watch('selections.type', function() {
            this.submit();
        });
    },

    methods: {
        clear() {
            this.selections = this.newSelections();
        },

        newSelections(query = {}) {
            return {
                location: this.selectionFromQuery('location', query.location),
                type: this.selectionFromQuery('types', query.type),
                zip: this.selectionFromQuery('zip', query.zip),
            };
        },

        selectionFromQuery(key, value) {
            if (!value) {
                return null;
            }

            if (key == 'location' || key == 'zip') {
                return value;
            }

            return this.filters[key].find(option => option.id == value);
        },

        getSelectionValue(key) {
            if (typeof this.selections[key] != 'object') {
                return this.selections[key] || null;
            }

            return this.selections[key] && this.selections[key].id;
        },

        formatNumber(number) {
            return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },

        countUp() {
            const animationDuration = 1000;
            const frameDuration = 1000 / 60;
            const totalFrames = Math.round(animationDuration / frameDuration);
            const easeOutQuad = t => t * (2 - t);
            let frame = 0;
            const countTo = this.totalLocations;

            const counter = setInterval(() => {
                frame++;
                const progress = easeOutQuad(frame / totalFrames);
                const currentCount = Math.round(countTo * progress);

                if (this.count !== currentCount) {
                    this.count = currentCount;
                }

                if (frame === totalFrames) {
                    clearInterval(counter);
                }
            }, frameDuration);
        },

        geolocate() {
            this.geolocating = true;
            navigator.geolocation.getCurrentPosition(position => {
                this.$store.dispatch('setDistanceFromLocations', position.coords);
                const latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                new google.maps.Geocoder().geocode({latLng}, (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        const zip = results[0].address_components.find(c => c.types.includes('postal_code'));
                        this.selections.zip = zip ? zip.long_name : null;
                        this.geolocating = false;
                    }
                });
            });
        },

        setLocationDistanceFromZip() {
            if (typeof google == 'undefined') {
                return;
            }

            if (!this.selections.zip) {
                this.$store.dispatch('clearDistanceFromLocations');
                return;
            }

            new google.maps.Geocoder().geocode({address: this.selections.zip}, (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                    const coordinates = results[0].geometry.location;
                    this.$store.dispatch('setDistanceFromLocations', {
                        latitude: coordinates.lat(),
                        longitude: coordinates.lng(),
                    });
                }
            });
        },

        submit() {
            this.$router.push({path: this.basePath, query: this.routeQuery});
            this.$store.dispatch('updateFilterSelections', this.routeQuery);
            this.$store.dispatch('getLocationFilters', this.routeQuery);

            this.$store.dispatch('getLocations', this.routeQuery);
        },
    },
};
</script>
